<template>
  <div class="wrapper box  box_v">
    <page-head title="防疫查重" :btn-list="btnList" :show-back="true" @handleBtn="handleBtn">
    </page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="姓名" prop="name">
                <Input v-model="name" placeholder="请输入姓名"/>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="身份证号" prop="cardno">
                <Input v-model="cardno" placeholder="请输入身份证号"/>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="isJiedao">
              <select-community ref="community" @communityChange="communityChange"></select-community>
            </i-col>
          </row>
        </i-form>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <div>
            <Button class="bkcc-btn del-btn" @click="delFangyi">删除</Button>
          </div>
          <Table border :columns="settingColumn" :data="fangyiList" :loading="isTableLoading"
                 @on-selection-change="selectTableItem" @on-row-click="clickRow"></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
    <Modal
      v-model="detailModal"
      title="详情"
      width="660px"
      :footer-hide="true"
    >
      <div class="people-detail">
        <div><i class="detail-title">姓名:</i>{{showItem.name}}</div>
        <div><i class="detail-title">所属社区:</i>{{showItem.communityName}}</div>
        <div><i class="detail-title">身份证:</i>{{showItem.cardno}}</div>
        <div><i class="detail-title">手机号:</i>{{showItem.phone}}</div>
        <div><i class="detail-title">现居住地:</i>{{showItem.address}}</div>
        <div><i class="detail-title">返回日期:</i>{{showItem.backTime}}</div>
        <div><i class="detail-title">返京前所在:</i>{{showItem.fromWhere}}</div>
        <div><i class="detail-title">回京方式:</i>{{showItem.returnWay}}</div>
        <div><i class="detail-title">航班/车次:</i>{{showItem.returnTrips}}</div>
        <div><i class="detail-title">自身症状:</i>{{handleSymptom(showItem.symptomSelf)}}</div>
        <div><i class="detail-title">备注:</i>{{showItem.remark}}</div>
      </div>
    </Modal>
    <Modal title="确认" v-model="delModal" @on-cancel="cancelModal" @on-ok="delFangyiItem">
      <div>确认删除记录吗？删除后将无法恢复</div>
    </Modal>
  </div>
</template>

<script>
  var that
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'

  export default {
    name: 'eqidemicRemoval',
    components: {
      pageHead,
      selectCommunity
    },
    data() {
      return {
        name: '',
        communityId: '',
        cardno: '',
        cityremark: '',
        btnList: [
          {
            name: '搜索',
            type: 'search',
            loading: false,
          }, {
            name: '重置',
            type: 'init',
            loading: false,
            btnType: 'default',
          }
        ],
        settingColumn: [],
        childShequ: [],
        fangyiList: [],
        isTableLoading: false,
        selectItem: [],
        page: 1,
        rows: 10,
        showItem: {},
        detailModal: false,
        total: 0,
        zoneId:'',
        symptomSelfList: [{
          label: '咳嗽',
          key: 1,
        },
          {
            label: '发烧',
            key: 4,
          },
          {
            label: '其他',
            key: 64,
          }, {
            label: '无症状',
            key: 0,
          }],
        symptom: {
          1: '咳嗽',
          2: '感冒',
          4: '发烧',
          8: '乏力',
          16: '呼吸困难',
          32: '腹泻',
          64: '其他',
          0: '以上均无'
        },
        delId:'',
        delModal:false,
        //级联行政区域
        communityIdList:[]
      }
    },
    computed: {
      isJiedao() {
        return parseInt(this.$store.state.isJiedao);
      },
      // 控制显示的内容
      handleSymptom() {
        var that = this
        return function (value) {
          return that.getIndexAry(value, that.symptom)
        }
      },
    },
    methods: {
      communityChange(value){
        console.log(value)
        this.communityId = value.communityId
        this.communityIdList = value.childrenIdList
        this.initFangyiList()
      },
      initTable() {
        this.settingColumn = [
          {
            type: 'selection',
            width: 70,
            align: 'center'
          }, 
          {
            title: "姓名",
            width: '95',
            resizable: true,
            key: "name"
          },
          {
            title: "身份证号",
            key: 'cardno',
            resizable: true,
          },
          {
            title: "联系电话",
            key: "phone",
            resizable: true,
          },
          {
            title: "行政区域",
            key: "communityName",
            resizable: true,
          },
          {
            title: '现居住地',
            key: 'address'
          },
          {
            title: "何地回" + this.cityremark,
            key: "fromWhere"
          },
          {
            title: "回" + this.cityremark + "日期",
            key: "backTime"
          },
          {
            title: "个人症状",
            width: '95',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.getIndexAry(that.fangyiList[params.index].symptomSelf,that.symptom)
                  )
                ]);
            }
          },{
            title: "登记时间",
            key: "createTime",
            width:'120',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.fangyiList[params.index].createTime.substring(0,that.fangyiList[params.index].createTime.length-2)
                  )
                ]);
            }
          },
          {
            title: "操作",
            width: 240,
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.getDetail(that.fangyiList[params.index].id)
                        }
                      }
                    },
                    "[详情]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.delItem(that.fangyiList[params.index].id)
                        }
                      }
                    },
                    "[删除]"
                  ),
                ]);
            }
          },
        ]
      },
      getChildShequ() {
        var url = this.urlobj.getChildShequ;
        this.$get(url).then(res => {
          var item = {
            name: '全部',
            id: 0,
          }
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: item.communityId
            };
          });
          list.unshift(item)
          this.childShequ = list
        });
      },
      initFangyiList() {
        this.page = 1
        this.getData()
      },
      getData() {
        var url = this.urlobj.fangyiChachong
        this.$post(url, {
          pageNum: this.page,
          pageSize: this.rows,
          communityIdList: this.communityIdList,
          name: this.name,
          cardno: this.cardno,
          zoneId:this.zoneId,
        }).then(res => {
          this.total = res.total
          this.fangyiList = res.rows
        })
      },
      pageChange(val) {
        this.page = val;
        this.getData();
      },
      clickRow(value) {
        var id = value.id
        this.getDetail(id)
      },
      getDetail(id) {
        console.log(id)
        this.$get(this.urlobj.getFangyiDetail(id)).then(res => {
          this.detailModal = true
          this.showItem = res.rows[0]
        })
      },
      selectTableItem(value) {
        this.selectItem = value
      },
      handleBtn(type) {
        if (type == 'search') {
          this.initFangyiList()
        } else if (type == 'init') {
          this.name = ''
          this.communityId = ''
          this.cardno = ''
          this.phoneNO = ''
          this.communityIdList = []
          this.$store.state.isJiedao && (this.$refs.community.selectCommunity="");
          this.initFangyiList()
        }
      },
      delItem(id){
        this.delModal = true
        this.delId = id
      },
      delFangyi() {
        var id = this.selectItem.map(item => item.id).join(',')
        if (!id) {
          this.$Message.warning('请选择要操作的记录')
          return
        }
        this.delModal = true
        this.delId = id
        // var list = this._.uniqBy(this.selectItem, 'idCardNO');
        // if (list.length != this.selectItem.length) {
        //   this.$Message.warning('重复数据至少保留一条')
        //   return
        // }
        //this.delFangyiItem(id)
      },
      delFangyiItem() {
        var url = this.urlobj.delFangyiList + '?idList=' + this.delId
        this.$delete(url).then(res => {
          this.$Message.success('操作成功')
          this.initFangyiList()
        })
      },
      getIndexAry(num, list) {
        let arr = Number(num)
          .toString(2)
          .split("");
        let len = arr.length - 1;
        let str = ''

        if (arr.length == 1 && arr[0] == 0) str = str + list[0] + ' '

        arr.map((item, index) => {
          if (+item) return +item * 2 ** (len - index);
        }).forEach(item => {
          if ((item != undefined)) str = str + list[item] + ' '
        })
        return str;
      }
    },
    mounted() {
      that = this
      this.cityremark = this.$route.query.cityremark || ''
      this.initTable()
      this.getData()
      if (this.$store.state.isJiedao) {
        this.getChildShequ();
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  .wrapper {
    height: 100%;
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .people-detail div {
    font-size: 16px;
    margin-bottom: 10px
  }

  .detail-title {
    width: 120px;
    text-align: right;
    margin-right: 10px;
    display: inline-block;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
